/**
 * 运费汇款单 内容 英文
 * Author:  Fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/9/16      1.0     FJJ
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import {toFixed2} from '@utils/utils';
import "../Bill.less";

export default class TableFreightRemittanceEn extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            orderInfo: {},

            loading: false,
        }
    }
    render(){
        const {orderInfo,  } = this.props;
        return ( <div className="padding-top-10 padding-bottom-10 color-black">
            <div className={"text-center font-bold"}>
                {/* 柜号 */}
                <p className="margin_bottom_20">DELIVERY AND ACCEPTANCE CERTIFICATE<span className={"margin-l-r-5 color-danger"}>{orderInfo.cabinetNumEn}</span></p>
                {/* 合同号和日期 */}
                <p className="font-16">to Contract No.<span className={"margin-l-r-5 color-danger"}>{orderInfo.contractCodeEn}</span>(hereinafter referred to as the Contract)</p>
            </div>
            {/* 日期 */}
            <p className="font-16 margin-top-md color-danger text-right">{orderInfo.dateEn}</p>
            {/* 描述 */}
            <p>FANRONG E-COMMERCE CO., LIMITED, represented by Director Ms. Anna Proskurnikova, hereinafter referred to as the "Contractor" on the one hand, and ESSAONE LLC (Russia), represented by General Director Vovk Tatiana Anatolievna, acting on the basis of the Charter, referred to as hereinafter, the "Customer", on the other hand, (hereinafter together - the Parties), have drawn up this Certificate as follows:</p>
            <p>Pursuant to the concluded Agreement, the Contractor has rendered the following services</p>
            <table className={"table-border"}>
                <tbody>
                    <tr>
                        <th width="100">No.</th>
                        <th>Service</th>
                    </tr>
                    <tr>
                        <td></td>
                        <td className={"color-black font-bold"}>{orderInfo.descEn}</td>
                    </tr>
                </tbody>
            </table>
            <p className={"padding-bottom-10"}>Services were rendered by the Contractor in a timely manner, in full, in compliance with the terms of the Agreement</p>
            <p className={"padding-bottom-10"}>The parties have no mutual claims to each other.</p>
            {/* 总运费 */}
            <div>For the services rendered, the Customer pays the Contractor money in the amount of<span className={"font-bold color-danger margin-l-r-5"}>{orderInfo.totalPriceEn}</span>CNY</div>
        </div>)
    }
}
